// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

import Animation from "./Animation.js";

export default class AboutAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.aboutText = this.element;
    //
    this.splittedText = SplitText.create(this.aboutText, {
      // linesClass: "line",
    });
    gsap.set(this.splittedText.words, { yPercent: 100, opacity: 0 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.splittedText.words, {
      opacity: 1,
      yPercent: 0,
      duration: 0.75,
      stagger: 0.015,
      ease: "power3.out",
    });

    return tl;
  }
}
